import { IconButton } from '@mui/material';
import React from 'react';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CircularProgress from "@mui/material/CircularProgress";

function ResourceHeaderCard({ resource, onEditClick, onDeleteClick, isLoading }) {
  return (
    <div style={{ display: "flex" }}>
      <h3 style={{ margin: "0 0.5em 0 0" }} >{resource.name}</h3>
      <>
        <IconButton disabled={isLoading} color="primary" onClick={onEditClick}> <EditOutlinedIcon/> </IconButton>
        <IconButton disabled={isLoading} color="primary" onClick={onDeleteClick}> { isLoading? <CircularProgress size="1rem"/>:  <DeleteOutlineOutlinedIcon/>} </IconButton>
      </>
    </div>
  );
}

export default ResourceHeaderCard;